document.addEventListener('turbolinks:load', () => {
  // Hashtag validation for source onboarding
  const hashtagsContainer = document.getElementById('select-hashtags');
  if (hashtagsContainer) {
    jQuery('.js-post-signup-capture-interests').on('submit', (evt) => {
      const hashtags = jQuery("#select-hashtags [name='hashtags[]']").map(function getHashtagValue() {
        return jQuery(this).val();
      }).get();

      // Validate that at least one category was selected
      if (hashtags.length === 0) {
        evt.preventDefault();

        // Trigger error state in React component by dispatching a custom event
        const selectorDiv = document.querySelector('.category-hashtag-selector');
        if (selectorDiv) {
          const validationEvent = new CustomEvent('showValidationError');
          selectorDiv.dispatchEvent(validationEvent);
        }

        // Scroll to the error message
        hashtagsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

        return false;
      }
    });
  }

  // Character counter for any text areas with data-target="char-counter"
  const textInput = document.querySelector('[data-target="char-counter"]');
  const charCounter = document.getElementById('char-counter');

  if (textInput && charCounter) {
    const updateCharCount = () => {
      charCounter.textContent = textInput.value.length;
    };

    updateCharCount();

    textInput.addEventListener('input', updateCharCount);
  }

  // URL validation for LinkedIn and showcase URL fields
  const linkedinField = document.getElementById('linkedin_profile_url');
  const showcaseField = document.getElementById('showcase_url');
  const form = document.querySelector('.js-post-signup-capture-interests form');

  // LinkedIn URL validation function (defined at this scope so it's accessible in form submit handler)
  const validateLinkedIn = () => {
    if (!linkedinField) return true;
      const value = linkedinField.value.trim();
      if (value === '') {
        // Empty is allowed (optional field)
        linkedinField.classList.remove('is-invalid');
        linkedinField.setCustomValidity('');
        return true;
      }

      // LinkedIn URL patterns
      const linkedInPattern = /^https?:\/\/(www\.)?linkedin\.com\/(in|pub|profile)\/[a-zA-Z0-9\-._~]+\/?$/i;
      const linkedInCompanyPattern = /^https?:\/\/(www\.)?linkedin\.com\/company\/[a-zA-Z0-9\-._~]+\/?$/i;

      if (!linkedInPattern.test(value) && !linkedInCompanyPattern.test(value)) {
        linkedinField.classList.add('is-invalid');
        linkedinField.setCustomValidity('Please enter a valid LinkedIn profile URL (e.g., https://www.linkedin.com/in/username)');

        // Add or update error message (account for input-group)
        const container = linkedinField.closest('.mb-4') || linkedinField.parentElement.parentElement;
        let errorDiv = container.querySelector('.invalid-feedback');
        if (!errorDiv) {
          errorDiv = document.createElement('div');
          errorDiv.className = 'invalid-feedback d-block';
          container.appendChild(errorDiv);
        }
        errorDiv.textContent = 'Please enter a valid LinkedIn profile URL';

        return false;
      }
      linkedinField.classList.remove('is-invalid');
      linkedinField.setCustomValidity('');
      return true;
  };

  // Showcase URL validation function (defined at this scope so it's accessible in form submit handler)
  const validateShowcaseURL = () => {
    if (!showcaseField) return true;
      const value = showcaseField.value.trim();
      if (value === '') {
        // Empty is allowed (optional field)
        showcaseField.classList.remove('is-invalid');
        showcaseField.setCustomValidity('');
        return true;
      }

      // General URL pattern - must start with http:// or https://
      const urlPattern = /^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w._~:/?#[\]@!$&'()*+,;=-]*)?$/i;

      if (!urlPattern.test(value)) {
        showcaseField.classList.add('is-invalid');
        showcaseField.setCustomValidity('Please enter a valid URL starting with http:// or https://');

        // Add or update error message
        let errorDiv = showcaseField.parentElement.querySelector('.invalid-feedback');
        if (!errorDiv) {
          errorDiv = document.createElement('div');
          errorDiv.className = 'invalid-feedback';
          showcaseField.parentElement.appendChild(errorDiv);
        }
        errorDiv.textContent = 'Please enter a valid URL starting with http:// or https://';

        return false;
      }
      showcaseField.classList.remove('is-invalid');
      showcaseField.setCustomValidity('');
      return true;
  };

  // Attach event listeners if fields exist
  if (linkedinField) {
    linkedinField.addEventListener('blur', validateLinkedIn);
    linkedinField.addEventListener('input', () => {
      // Clear error state on input
      if (linkedinField.classList.contains('is-invalid')) {
        validateLinkedIn();
      }
    });
  }

  if (showcaseField) {
    showcaseField.addEventListener('blur', validateShowcaseURL);
    showcaseField.addEventListener('input', () => {
      // Clear error state on input
      if (showcaseField.classList.contains('is-invalid')) {
        validateShowcaseURL();
      }
    });
  }

  // Form submission validation
  if (form) {
    form.addEventListener('submit', (evt) => {
      let isValid = true;

      // Validate LinkedIn if present
      if (linkedinField) {
        const linkedinValid = validateLinkedIn();
        isValid = isValid && linkedinValid;
      }

      // Validate showcase URL if present
      if (showcaseField) {
        const showcaseValid = validateShowcaseURL();
        isValid = isValid && showcaseValid;
      }

      if (!isValid) {
        evt.preventDefault();
        evt.stopPropagation();

        // Focus on first invalid field
        const firstInvalid = form.querySelector('.is-invalid');
        if (firstInvalid) {
          firstInvalid.focus();
        }
      }
    });
  }
});
